import { NgIf } from '@angular/common';
import { Component, Input, inject } from '@angular/core';
import { PricingService } from 'src/app/services/pricing.service';
import { PictureComponent } from '../../../shared/components/picture/picture.component';
import { SvgComponent } from '../../../shared/components/svg/svg.component';
import { ResizeDirective } from '../../../shared/directives/resize.directive';

@Component({
  selector: 'app-pre-footer',
  templateUrl: './pre-footer.component.html',
  styleUrls: ['./pre-footer.component.scss'],
  standalone: true,
  imports: [SvgComponent, ResizeDirective, PictureComponent, NgIf],
})
export class PreFooterComponent {
  @Input() dark: boolean;
  @Input() black: boolean;
  @Input() title = 'Experience Picflow with a Free Trial';
  @Input() darkImage: string;
  @Input() lightImage: string;
  trialLengthDays: number;

  private pricingService = inject(PricingService);

  defaultDarkImage = 'https://assets.picflow.com/1844x802/477bed6680/pre-footer-dark.jpeg';
  defaultLightImage = 'https://assets.picflow.com/1920x884/8810211bad/pre-footer-light.png';

  constructor() {
    this.trialLengthDays = this.pricingService.getTrialLengthDays();
  }
}
